import { MenuItem, Typography } from '@mui/material';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import QuorumBusiness from '@/dominio/QuorumBusiness';
import { FilterAlt } from '@mui/icons-material';

class AlertaProcessosSemQuorumMinimo extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            quantidadeProcessosSemQuorumMinimo: computed,
            handleClickIcone: action
        });
    }

    get quantidadeProcessosSemQuorumMinimo() {
        return this.observableProps.processos.length;
    }

    handleClickIcone = () => {
        this.store.alterandoValorFiltro = true;
        this.setTimeout(() => {
            this.store.filtros.reset();
            this.store.filtros.filtroQuorumMinimo.valor = false;
            this.store.alterandoValorFiltro = false;
        });
    };

    render() {
        if (!this.quantidadeProcessosSemQuorumMinimo || this.quantidadeProcessosSemQuorumMinimo <= 0) {
            return null;
        }

        return (
            <MenuItem
                style={{ display: 'flex', cursor: 'pointer' }}
                onClick={this.handleClickIcone}
            >
                <FilterAlt style={{ marginRight: '12px', color: 'darkorange', fillOpacity: '1' }} />
                <Typography>
                    {this.quantidadeProcessosSemQuorumMinimo +
                        ' processo' +
                        (this.quantidadeProcessosSemQuorumMinimo === 1 ? '' : 's')}{' '}
                    cujo total de participantes (elementos na composição)
                    <br />é inferior ao atributo quórum mínimo da sessão
                </Typography>
            </MenuItem>
        );
    }
}

export default inject('stores')(observer(AlertaProcessosSemQuorumMinimo));
